import React, {ReactNode} from 'react';
import {useSearchParams} from 'react-router-dom';

import {FILTERS_KEPT_PARAMS, resetFiltersSearchParams} from 'shared/lib/filterHelper';

import MainModal from '../MainModal';

interface IFiltersModalProps {
    header: string,
    open: boolean,
    handleClose: () => void,
    children: ReactNode,
    keepParams?: readonly string[],
    withReset?: boolean,
}

const FiltersModal: React.FC<IFiltersModalProps> = ({
    header,
    open,
    handleClose,
    children,
    keepParams = FILTERS_KEPT_PARAMS,
    withReset = true,
}) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const handleResetFilters = () => {
        setSearchParams(resetFiltersSearchParams(searchParams, keepParams));
        handleClose();
    };

    return (
        <MainModal
            header={header}
            open={open}
            handleClose={handleClose}
            size="md"
            isButtonResetFilters={withReset}
            onResetFilters={withReset ? handleResetFilters : undefined}
        >
            {children}
        </MainModal>
    );
};

export default FiltersModal;
